/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recognition_Level_Two_TitleInputs */

const en_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level 2 Seller`)
};

const ar_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بائع المستوى الثاني`)
};

const bn_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লেভেল ২ সেলার`)
};

const de_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer der Stufe 2`)
};

const es_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor nivel 2`)
};

const fr_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeur de niveau 2`)
};

const pt_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor nível 2`)
};

const zh_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 级卖家`)
};

const tr_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Seviye Satıcı`)
};

const ru_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавец 2 уровня`)
};

const pl_recognition_level_two_title = /** @type {(inputs: Recognition_Level_Two_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawca poziomu 2`)
};

/**
* | output |
* | --- |
* | "Level 2 Seller" |
*
* @param {Recognition_Level_Two_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const recognition_level_two_title = /** @type {((inputs?: Recognition_Level_Two_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recognition_Level_Two_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_recognition_level_two_title(inputs)
	if (locale === "bn") return bn_recognition_level_two_title(inputs)
	if (locale === "de") return de_recognition_level_two_title(inputs)
	if (locale === "es") return es_recognition_level_two_title(inputs)
	if (locale === "fr") return fr_recognition_level_two_title(inputs)
	if (locale === "pt") return pt_recognition_level_two_title(inputs)
	if (locale === "zh") return zh_recognition_level_two_title(inputs)
	if (locale === "tr") return tr_recognition_level_two_title(inputs)
	if (locale === "ru") return ru_recognition_level_two_title(inputs)
	if (locale === "pl") return pl_recognition_level_two_title(inputs)
	return en_recognition_level_two_title(inputs)
});